export const productsConstants = {
  PRODUCTS_REQUEST: 'PRODUCTS_REQUEST',
  PRODUCTS_SUCCESS: 'PRODUCTS_SUCCESS',
  PRODUCTS_FAILURE: 'PRODUCTS_FAILURE',
};
